import { Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import SimpleTable from "components/Tables/SimpleTable";
import dataMedidas from "./dataMedidas";
import SinDatos from "components/Carteles/SinDatos";
import Firma from "../Firma";

const MedidasDeSeguridad = ({ listadoMedidas }) => {
  const { columns, getRows } = dataMedidas;

  const memoizedRows = useMemo(() => {
    if (listadoMedidas) {
      const listadoSinBorrar = listadoMedidas.filter((item) => !item.aBorrar);
      return getRows(listadoSinBorrar);
    }
    return [];
  }, [listadoMedidas]);

  return (
    <Grid container p={2}>
      <Grid item xs={12}>
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          Medidas de Seguridad
        </SoftTypography>
      </Grid>
      <Grid item xs={12} py={1}>
        {listadoMedidas?.filter((item) => !item.aBorrar).length > 0 ? (
          <SimpleTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay medidas de seguridad registradas" />
        )}
      </Grid>
      <Firma marginTop={10} />
    </Grid>
  );
};

export default memo(MedidasDeSeguridad);

MedidasDeSeguridad.propTypes = {
  listadoMedidas: PropTypes.array.isRequired,
};
